var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "14",
        height: "18",
        viewBox: "0 0 14 18",
        fill: "none",
      },
    },
    [
      _c("g", { attrs: { "clip-path": "url(#clip0_379_5557)" } }, [
        _c("path", {
          attrs: {
            d: "M4.225 0.622266C4.39375 0.239063 4.74062 0 5.11875 0H8.88125C9.25938 0 9.60625 0.239063 9.775 0.622266L10 1.125H13C13.5531 1.125 14 1.62773 14 2.25C14 2.87227 13.5531 3.375 13 3.375H1C0.446875 3.375 0 2.87227 0 2.25C0 1.62773 0.446875 1.125 1 1.125H4L4.225 0.622266ZM1 4.5H13V15.75C13 16.991 12.1031 18 11 18H3C1.89688 18 1 16.991 1 15.75V4.5ZM4 6.75C3.725 6.75 3.5 7.00313 3.5 7.3125V15.1875C3.5 15.4969 3.725 15.75 4 15.75C4.275 15.75 4.5 15.4969 4.5 15.1875V7.3125C4.5 7.00313 4.275 6.75 4 6.75ZM7 6.75C6.725 6.75 6.5 7.00313 6.5 7.3125V15.1875C6.5 15.4969 6.725 15.75 7 15.75C7.275 15.75 7.5 15.4969 7.5 15.1875V7.3125C7.5 7.00313 7.275 6.75 7 6.75ZM10 6.75C9.725 6.75 9.5 7.00313 9.5 7.3125V15.1875C9.5 15.4969 9.725 15.75 10 15.75C10.275 15.75 10.5 15.4969 10.5 15.1875V7.3125C10.5 7.00313 10.275 6.75 10 6.75Z",
            fill: "#010A11",
          },
        }),
      ]),
      _c("defs", [
        _c("clipPath", { attrs: { id: "clip0_379_5557" } }, [
          _c("rect", { attrs: { width: "14", height: "18", fill: "white" } }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }